<template>
    <modal @close="approvePromotionCancelClick" id="approve-promotion" hide-footer>
        <h4 class="td-h4">Please confirm</h4>
        <p class="ma-0">
            Are you sure you want to approve this promotion?  It will begin displaying immediately after funds are available.
        </p>
        <div class="actions mt-3">
            <button class="td-btn danger" @click="approvePromotionSaveClick"><span v-if="isLoading"><icon name="faSpinner" type="solid" spin></icon>&nbsp;</span>Approve</button>
        </div>
    </modal>
</template>

<script>
    import script from './Approve';
    export default script;
</script>
<style lang="less">
    @import './Approve.less';
</style>